export function downloadBase64({ base64, filename }) {
  const alink = document.createElement('a');
  alink.href = base64;
  alink.download = filename;
  alink.click();
}
